export const COURSETYPES = [
  { label: 'Diploma', value: 'diploma' },
  { label: 'Certificate', value: 'certificate' }
];
